import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';

import AutoComplete from '../Common/AutoComplete';
import { Card, CardActions, CardHeader, CardText } from 'material-ui/Card';
import Dialog from 'material-ui/Dialog';
import Chip from 'material-ui/Chip';
import ErrorSnackbar from '../Common/ErrorSnackbar';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';

import ModuleActions from '../../actions/ModuleActionCreator';
import ModuleAccessGroupStore from '../../stores/ModuleAccessGroupStore';
import AccessGroupIcon from 'material-ui/svg-icons/action/group-work';

const styles = {
    chip: {
        margin: 4,
    },
};


class ModuleAccessGroupSegment extends Component {

    componentDidMount() {
        this.addAccessGroup = this.addAccessGroup.bind(this);
        this.removeAccessGroup = this.removeAccessGroup.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.addAction = this.addAction.bind(this);
        this.removeAction = this.removeAction.bind(this);

        ModuleActions.getAccessGroups(this.state.moduleId);
    }

    render() {

        const iconProps = {
            color: 'rgba(117, 117, 117 ,0.7)',
        };

        const avatarIcon = (<AccessGroupIcon {...iconProps}/>);

        let accessGroups;
        if (!!this.context.auth.identity && !!this.context.auth.identity.accessGroups && 0 < this.context.auth.identity.accessGroups.length) {
            accessGroups = this.context.auth.identity.accessGroups.map((accessGroup) => {
                const click = this.onSelectAccessGroup.bind(this, accessGroup);
                return {
                    id: accessGroup.id,
                    name: accessGroup.name,
                    text: accessGroup.name,
                    value: <MenuItem key={accessGroup.id} value={accessGroup.id} primaryText={accessGroup.name} onTouchTap={click}/>,
                };
            }, this);
        }

        return (
            <Card className="cent-card">
                <CardHeader
                    title='Access'
                    subtitle='manage access across organisational units'
                    avatar={avatarIcon}
                />
                <CardText className="cent-card-text">
                    {this.state.accessGroups.map( ({name, id}) => (
                        <Chip
                            key={id}
                            style={styles.chip}
                            onRequestDelete={ () => this.removeAccessGroup(id) }
                        >{name}
                        </Chip>
                    ))}
                </CardText>
                <CardActions>
                    <FlatButton label="Add" onTouchTap={this.addAction} />
                </CardActions>
                {!!this.state.dialogTitle && (
                    <Dialog
                        title={`${this.state.dialogTitle} Access Group`}
                        open={this.state.dialogOpen}
                        modal={false}
                        onRequestClose={this.closeDialog}
                        actions={[
                            <FlatButton key="cancel" label="Cancel" onTouchTap={this.closeDialog}/>,
                            <FlatButton
                                key="submit"
                                label={this.state.dialogTitle}
                                onTouchTap={this.state.dialogAction}
                                disabled={this.state.dialogTitle === 'Add' && !this.state.dialogValue}
                            />
                        ]}
                        >
                        {this.state.dialogTitle === 'Add' &&
                            <AutoComplete
                                floatingLabelText="Access group"
                                maxSearchResults={5}
                                dataSource={accessGroups}
                            />
                        }
                        {this.state.dialogTitle === 'Remove' &&
                            'If all access groups are removed you might lose access to this module. Continue?'
                        }
                    </Dialog>
                )}
                <ErrorSnackbar/>
            </Card>
        );
    }

    addAccessGroup() {
        ModuleActions.addAccessGroup(this.state.moduleId, this.state.dialogValue.id);
        this.closeDialog();
    }

    removeAccessGroup(accessGroupId) {
        ModuleActions.removeAccessGroup(this.state.moduleId, accessGroupId);
        this.closeDialog();
    }

    addAction() {
        this.setState({
            dialogTitle:  'Add',
            dialogAction: this.addAccessGroup,
            dialogOpen:   true
        });
    }

    removeAction(accessGroupId) {
        if (this.context.auth.isRoot() || this.state.accessGroups.length > 1) {
            ModuleActions.removeAccessGroup(this.state.moduleId, accessGroupId);
        } else {
            this.setState({
                dialogTitle:  'Remove',
                dialogAction: () => this.removeAccessGroup(accessGroupId),
                dialogOpen:   true
            });
        }
    }

    closeDialog() {
        this.setState({dialogOpen: false, dialogValue: null});
    }

    onSelectAccessGroup(accessGroup) {
        this.setState({dialogValue: accessGroup});
    }
}

ModuleAccessGroupSegment.contextTypes = {
    auth: PropTypes.object.isRequired
};

ModuleAccessGroupSegment.getStores = () => ([ModuleAccessGroupStore]);

ModuleAccessGroupSegment.calculateState = (prevState, {moduleId}) => ({
    moduleId,
    accessGroups: ModuleAccessGroupStore.getByModule(Number(moduleId))
});

export default Container.create(ModuleAccessGroupSegment, {withProps: true});
